import { render } from "./ArtTile.vue?vue&type=template&id=6b53e921&scoped=true"
import script from "./ArtTile.vue?vue&type=script&lang=js"
export * from "./ArtTile.vue?vue&type=script&lang=js"

import "./ArtTile.vue?vue&type=style&index=0&id=6b53e921&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b53e921"]])

export default __exports__